import Slides from './Slides.js';

import img1 from './images/portfolio/weddings-and-engagements/4/317.jpg';
import img2 from './images/portfolio/weddings-and-engagements/4/326-2.jpg';
import img3 from './images/portfolio/weddings-and-engagements/4/344.jpg';
import img4 from './images/portfolio/weddings-and-engagements/4/358.jpg';
import img5 from './images/portfolio/weddings-and-engagements/4/361.jpg';
import img6 from './images/portfolio/weddings-and-engagements/4/384.jpg';
import img7 from './images/portfolio/weddings-and-engagements/4/394.jpg';
import img8 from './images/portfolio/weddings-and-engagements/4/396.jpg';
import img9 from './images/portfolio/weddings-and-engagements/4/407_DSC8594.jpg';
import img10 from './images/portfolio/weddings-and-engagements/4/415_IMG1545.jpg';
import img11 from './images/portfolio/weddings-and-engagements/4/469.jpg';
import img12 from './images/portfolio/weddings-and-engagements/4/476.jpg';
import img13 from './images/portfolio/weddings-and-engagements/4/606_IMG2266.jpg';
import img14 from './images/portfolio/weddings-and-engagements/4/731_IMG2284.jpg';
import img15 from './images/portfolio/weddings-and-engagements/4/963_IMG2440.jpg';
import img16 from './images/portfolio/weddings-and-engagements/4/Cover_2_0682_IMG5698.jpg';
import img17 from './images/portfolio/weddings-and-engagements/4/Duotone.jpg';
import img18 from './images/portfolio/weddings-and-engagements/4/Grande-Wasserman42.jpg';
import img19 from './images/portfolio/weddings-and-engagements/4/IMG_346.jpg';
import img20 from './images/portfolio/weddings-and-engagements/4/Image023.jpg';
import img21 from './images/portfolio/weddings-and-engagements/4/Img0017.jpg';
import img22 from './images/portfolio/weddings-and-engagements/4/Img0159.jpg';

const images = [ 
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img19,
    img20,
    img21,
    img22,
];

function Architectural() {
    return <Slides images={images}/>;
}

export default Architectural;
